import { action } from 'satcheljs';
export default action('REQUEST_MAILBOX_EXPORT');
//# sourceMappingURL=requestMailboxExport.js.map